import {ListActionButton} from "components/common";
import {ColumnsEdit} from "types/models/column-table-edit";
import React from "react";

const supplierCatalogColumns: ColumnsEdit = [
  {
    title: "STT",
    dataIndex: "stt",
    key: "stt",
    render: (text, record, index) => index + 1,
    width: "4%",
    align: "center",
  },
  {
    title: "Mã NCC",
    dataIndex: "id",
    key: "id",
    show: true,
    align: "left",
  },
  {
    title: "Tên NCC",
    dataIndex: "name",
    key: "name",
    show: true,
    align: "left",
  },
  {
    title: "Địa chỉ",
    dataIndex: "address",
    key: "address",
    show: true,
    align: "left",
  },
  {
    title: "Người đại diện",
    dataIndex: "representative",
    key: "representative",
    show: true,
    align: "left",
  },
  {
    title: "Điện thoại",
    dataIndex: "phone",
    key: "phone",
    show: true,
    align: "left",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
    show: true,
    align: "left",
  },
  {
    title: "Các nhóm mặt hàng",
    dataIndex: "commodityGroups",
    key: "commodityGroups",
    show: true,
    align: "left",
  },
  {
    title: "Thao tác",
    key: "action",
    dataIndex: "action",
    show: true,
    width: 80,
  },
];

export {supplierCatalogColumns};
